module.exports = __webpack_public_path__ + "img/mxr-m117r-flanger.0f59749d.jpg";